import { useRef, useLayoutEffect } from "react"
import PropTypes from "prop-types"
import { prepare, layout } from "@chenglou/pretext"

const Fittty = ({ minSize, maxSize, mode, text }) => {
  const innerRef = useRef(null)

  useLayoutEffect(() => {
    const innerEl = innerRef.current
    if (!innerEl || !text) return

    const containerEl = innerEl.parentElement
    if (!containerEl) return

    const computed = getComputedStyle(innerEl)
    const fontFamily = computed.fontFamily
    const fontWeight = computed.fontWeight
    const containerWidth = containerEl.clientWidth
    const containerHeight = containerEl.clientHeight

    let minFs = minSize
    let maxFs = maxSize
    const precision = 0.1

    while (maxFs - minFs > precision) {
      const mid = (minFs + maxFs) / 2
      const font = `${fontWeight} ${mid}px ${fontFamily}`
      const prepared = prepare(text, font)
      const lineHeight = mid * 1.2

      if (mode === "oneline") {
        const { lineCount } = layout(prepared, containerWidth, lineHeight)
        if (lineCount <= 1) {
          minFs = mid
        } else {
          maxFs = mid
        }
      } else {
        const { height } = layout(prepared, containerWidth, lineHeight)
        if (height <= containerHeight) {
          minFs = mid
        } else {
          maxFs = mid
        }
      }
    }

    innerEl.style.fontSize = `${minFs}px`
  }, [text, minSize, maxSize, mode])

  return <span ref={innerRef}>{text}</span>
}

Fittty.propTypes = {
  text: PropTypes.string.isRequired,
  minSize: PropTypes.number,
  maxSize: PropTypes.number,
  mode: PropTypes.string,
}

Fittty.defaultProps = {
  minSize: 20,
  maxSize: 52,
  mode: "oneline",
}

export default Fittty
